import { render, staticRenderFns } from "./checkboxComponent.vue?vue&type=template&id=1300525c&"
import script from "./checkboxComponent.vue?vue&type=script&lang=js&"
export * from "./checkboxComponent.vue?vue&type=script&lang=js&"
import style0 from "./checkboxComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1300525c')) {
      api.createRecord('1300525c', component.options)
    } else {
      api.reload('1300525c', component.options)
    }
    module.hot.accept("./checkboxComponent.vue?vue&type=template&id=1300525c&", function () {
      api.rerender('1300525c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/checkbox/checkboxComponent.vue"
export default component.exports